var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSynergiesTable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M.5.5h15v15H.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M.5.5h15v3H.5zM.5 3.5h5v12h-5zM10.5 3.5h5v12h-5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M.5 11.5h15v4H.5zM.5 3.5h15v4H.5z"
  })));
}

export default SvgSynergiesTable;